import { KeycloakUserInfo } from '@auth/models/UserInfo.model';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { USER_TYPE } from '@shared/models/UserType.model';
import { KeycloakTokenParsed } from 'keycloak-js';

interface AuthState {
  isAuthenticated: boolean;
  user: KeycloakUserInfo | null;
  userType: USER_TYPE | null;
  tokenParsed?: KeycloakTokenParsed;
  isBiometricEnabled?: boolean;
  isBiometricAvailable?: boolean;
  biometricType?: string | null;
  wasRestoredFromStorage?: boolean; // Track if auth was restored on cold start
}

const initialState: AuthState = {
  isAuthenticated: false,
  user: null,
  userType: null,
  tokenParsed: undefined,
  isBiometricEnabled: false,
  isBiometricAvailable: false,
  biometricType: null,
  wasRestoredFromStorage: false
};

export const appSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess: (state, action: PayloadAction<AuthState>) => {
      state.isAuthenticated = true;
      state.userType = action.payload.userType;
      state.user = action.payload.user;
      state.tokenParsed = action.payload.tokenParsed;
      state.wasRestoredFromStorage = action.payload.wasRestoredFromStorage || false;
    },
    setBiometricState: (
      state,
      action: PayloadAction<{ enabled: boolean; available: boolean; type?: string | null }>
    ) => {
      state.isBiometricEnabled = action.payload.enabled;
      state.isBiometricAvailable = action.payload.available;
      state.biometricType = action.payload.type;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.userType = null;
      state.user = null;
      state.tokenParsed = undefined;
      state.isBiometricEnabled = false;
      state.isBiometricAvailable = false;
      state.biometricType = undefined;
    }
  }
});

export const AuthActions = appSlice.actions;
export const AuthReducer = appSlice.reducer;
